<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-data-table
          :headers="tableHeaders"
          :items="desserts"
          :sort-by="['name']"
          :sort-desc="[true]"
          :loading="loading"
          @click:row="onRowClick">
            <template v-slot:item.address="{ item }">
              〒{{ item.post }} {{ item.pref }}{{ item.address }} {{ item.build }}
            </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="800" id="dialog">
        <v-card flat class="drawer-card">
          <v-card-title>
            <div class="title">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</div>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                  <ul class="list-inline">
                    <li class="mr-3">
                      <Upload :file.sync="editedItem.logo" @lightbox="lightboxFunc" label="ロゴ" />
                    </li>
                    <li>
                      <Upload :file.sync="editedItem.sign" @lightbox="lightboxFunc" label="社印" />
                    </li>
                  </ul>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="name"
                    label="会社名"
                    v-model="editedItem.name"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="furigana"
                    label="会社名フリガナ"
                    v-model="editedItem.furigana"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-text-field
                    ref="post"
                    label="郵便番号"
                    v-model="editedItem.post"
                    :rules="[rules.required]"
                    class="required"
                    prefix="〒"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="8" class="pa-2">
                  <v-combobox
                    ref="pref"
                    label="都道府県"
                    v-model="editedItem.pref"
                    :items="prefs"
                    :rules="[rules.required]"
                    class="required"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('pref')"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="address"
                    label="住所"
                    v-model="editedItem.address"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field
                    ref="build"
                    label="ビル・建物等"
                    v-model="editedItem.build"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="tel"
                    label="電話番号(ハイフンあり)"
                    type="tel"
                    v-model="editedItem.tel"
                    :rules="[rules.tel]"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field
                    ref="fax"
                    label="FAX番号(ハイフンあり)"
                    type="tel"
                    v-model="editedItem.fax"
                    :rules="[rules.tel]"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
              </v-row>

              <div class="section-title">伝票</div>
              <v-row no-gutters>
                <v-col cols="4" class="pa-2">
                  <v-combobox
                    ref="slipFormat"
                    label="出力フォーマット"
                    v-model="editedItem.slipFormat"
                    :items="formats"
                    :rules="[rules.required]"
                    class="required"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('slipFormat')"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-combobox
                    ref="startMonth"
                    label="起算月"
                    v-model="editedItem.startMonth"
                    :items="months"
                    :rules="[rules.required]"
                    class="required"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('startMonth')"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </v-col>
                <v-col cols="4" class="pa-2">
                  <v-text-field
                    ref="invoice"
                    label="インボイス制度 登録番号"
                    v-model="editedItem.invoice"
                    outlined hide-details="auto">
                  </v-text-field>
                </v-col>
              </v-row>

              <div class="section-title">口座情報</div>
              <v-data-table
                :headers="itemHeaders"
                :items="editedItem.bank"
                class="bank-table"
                hide-default-footer
                disable-pagination>
                <template v-slot:body="{ items }">
                  <draggable 
                    v-model="editedItem.bank" 
                    tag="tbody" 
                    handle=".handle"
                    class="draggable-table"
                    ghost-class="ghost">
                    <tr v-for="(item, index) in items" :key="index">
                      <td>
                        <span class="handle">
                          <v-icon small>fas fa-bars</v-icon>
                        </span>
                      </td>
                      <td>
                        <v-text-field v-model="item.name" 
                          :rules="[rules.required]"
                          dense hide-details="auto"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.store"
                          :rules="[rules.required]"
                          dense hide-details="auto"></v-text-field>
                      </td>
                      <td>
                        <v-combobox v-model="item.type" 
                          :items="types"
                          :rules="[rules.required]"
                          dense hide-details="auto"></v-combobox>
                      </td>
                      <td>
                        <v-text-field v-model="item.no"
                          :rules="[rules.required]"
                          dense hide-details="auto"></v-text-field>
                      </td>
                      <td>
                        <v-text-field v-model="item.owner"
                          :rules="[rules.required]"
                          dense hide-details="auto"></v-text-field>
                      </td>
                      <td>
                        <span @click="trashBank(index)">
                          <v-icon small>fas fa-times</v-icon>
                        </span>
                      </td>
                    </tr>
                  </draggable>
                  <tbody>
                    <tr class="table-footer">
                      <td class="row-ctrl"></td>
                      <td class="row-ctrl" colspan="6">
                        <v-btn small text @click.stop="addBankRow">
                          <v-icon left>far fa-plus-square</v-icon>
                          行の追加
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>

              <div class="section-title">支店・営業所</div>
              <v-data-table
                :headers="officeHeaders"
                :items="editedItem.office"
                class="bank-table"
                hide-default-footer
                disable-pagination>
                <template v-slot:body="{ items }">
                  <draggable 
                    v-model="editedItem.office" 
                    tag="tbody" 
                    handle=".handle"
                    class="draggable-table"
                    ghost-class="ghost">
                    <tr v-for="(item, index) in items" :key="index">
                      <td>
                        <span class="handle">
                          <v-icon small>fas fa-bars</v-icon>
                        </span>
                      </td>
                      <td class="py-2">
                        <v-row no-gutters>
                          <v-col cols="12" class="pa-2">
                            <v-text-field v-model="item.name" 
                              label="名称"
                              :rules="[rules.required]"
                              class="required"
                              dense hide-details="auto"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="pa-2">
                            <v-text-field v-model="item.post"
                              label="郵便番号"
                              :rules="[rules.required]"
                              class="required"
                              prefix="〒"
                              dense hide-details="auto"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="pa-2">
                            <v-combobox v-model="item.pref" 
                              label="都道府県"
                              :items="prefs"
                              :rules="[rules.required]"
                              class="required"
                              dense hide-details="auto"></v-combobox>
                          </v-col>
                          <v-col cols="8" class="pa-2">
                            <v-text-field v-model="item.address"
                              label="住所"
                              :rules="[rules.required]"
                              class="required"
                              dense hide-details="auto"></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pa-2">
                            <v-text-field v-model="item.build"
                              label="ビル・建物等"
                              dense hide-details="auto"></v-text-field>
                          </v-col>
                          <v-col cols="3" class="pa-2">
                            <v-text-field v-model="item.tel"
                              label="電話番号"
                              dense hide-details="auto"></v-text-field>
                          </v-col>
                          <v-col cols="3" class="pa-2">
                            <v-text-field v-model="item.fax"
                              label="FAX番号"
                              dense hide-details="auto"></v-text-field>
                          </v-col>
                        </v-row>
                      </td>
                      <td>
                        <span @click="trashOffice(index)">
                          <v-icon small>fas fa-times</v-icon>
                        </span>
                      </td>
                    </tr>
                  </draggable>
                  <tbody>
                    <tr class="table-footer">
                      <td class="row-ctrl"></td>
                      <td class="row-ctrl" colspan="7">
                        <v-btn small text @click.stop="addOfficeRow">
                          <v-icon left>far fa-plus-square</v-icon>
                          行の追加
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { 
  createCorporate, updateCorporate, deleteCorporate,
  createBank, updateBank, deleteBank,
  createOffice, updateOffice, deleteOffice } from '../graphql/mutations'
import { listCorporates } from '../graphql/queries'
import { 
  onCreateCorporate, onUpdateCorporate, onDeleteCorporate,
  onCreateBank, onUpdateBank, onDeleteBank,
  onCreateOffice, onUpdateOffice, onDeleteOffice } from '../graphql/subscriptions'
import Upload from '@/components/Upload'
import draggable from 'vuedraggable' 

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '会社名', align: 'start', value: 'name' },
        { text: '住所', align: 'start', value: 'address' },
        { text: 'TEL', align: 'start', value: 'tel' },
        { text: 'FAX', align: 'start', value: 'fax' },
      ],
      itemHeaders: [
        { text: '', align: 'center', value: '', sortable: false, width: 20 },
        { text: '銀行', align: 'start', value: 'name', sortable: false, width: 150 },
        { text: '支店', align: 'start', value: 'store', sortable: false, width: 120 },
        { text: '種別', align: 'start', value: 'type', sortable: false, width: 100 },
        { text: '口座番号', align: 'start', value: 'no', sortable: false, width: 120 },
        { text: '名義', align: 'start', value: 'owner', sortable: false },
        { text: '', align: 'center', value: '', sortable: false, width: 30 },
      ],
      officeHeaders: [
        { text: '', align: 'center', value: '', sortable: false, width: 20 },
        { text: '', align: 'start', value: 'name', sortable: false },
        { text: '', align: 'center', value: '', sortable: false, width: 30 },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      editedIndex: -1,
      editedItem: {
        bank: [],
        office: [],
      },
      types: ['普通', '当座'],
      formats: ['タイプA', 'タイプB'],
      bankOrigin: [],
      officeOrigin: [],
    }
  },
  prop: {},
  mounted: async function() {
    //一覧 query
    await this.getCorporates()
    //Corporate
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateCorporate)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateCorporate
        this.desserts.push(data)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateCorporate)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateCorporate
        this.desserts.find(origin => {
          if (origin.id === data.id) {
            origin = Object.assign(origin, data)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteCorporate)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteCorporate
        this.desserts = this.desserts.filter(origin => origin.id !== data.id)
      }
    })
    //Bank
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateBank)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateBank
        const corporate = this.desserts.find(origin => origin.id == data.corporateID)
        corporate.bank.items.push(data)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateBank)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateBank
        const corporate = this.desserts.find(origin => origin.id == data.corporateID)
        corporate.bank.items.find(origin => {
          if (origin.id === data.id) {
            origin = Object.assign(origin, data)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteBank)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteBank
        const corporate = this.desserts.find(origin => origin.id == data.corporateID)
        corporate.bank.items = corporate.bank.items.filter(origin => origin.id !== data.id)
      }
    })
    //Office
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateOffice)).subscribe({
      next: (e) => {
        const data = e.value.data.onCreateOffice
        const corporate = this.desserts.find(origin => origin.id == data.corporateID)
        corporate.office.items.push(data)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateOffice)).subscribe({
      next: (e) => {
        const data = e.value.data.onUpdateOffice
        const corporate = this.desserts.find(origin => origin.id == data.corporateID)
        corporate.office.items.find(origin => {
          if (origin.id === data.id) {
            origin = Object.assign(origin, data)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteOffice)).subscribe({
      next: (e) => {
        const data = e.value.data.onDeleteOffice
        const corporate = this.desserts.find(origin => origin.id == data.corporateID)
        corporate.office.items = corporate.office.items.filter(origin => origin.id !== data.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    form() {
      return {
        id: this.editedItem.id || null,
        name: this.editedItem.name || null,
        furigana: this.editedItem.furigana || null,
        post: this.editedItem.post || null,
        pref: this.editedItem.pref || null,
        address: this.editedItem.address || null,
        build: this.editedItem.build || null,
        tel: this.editedItem.tel || null,
        fax: this.editedItem.fax || null,
        logo: this.editedItem.logo || null,
        sign: this.editedItem.sign || null,
        slipFormat: this.editedItem.slipFormat || null,
        startMonth: this.editedItem.startMonth ? this.editedItem.startMonth.value : null,
        invoice: this.editedItem.invoice || null,
      }
    },
    months() {
      const map = []

      for (let i=1; i<=12; i++) {
        map.push({ value: i, text: i + '月' })
      }

      return map
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //行選択
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)
      //口座
      this.bankOrigin = [...this.editedItem.bank.items]
      this.editedItem.bank = this.editedItem.bank.items
      //支店・営業所
      this.officeOrigin = [...this.editedItem.office.items]
      this.editedItem.office = this.editedItem.office.items
      //起算月
      if (params.startMonth) {
        this.editedItem.startMonth = this.months.find(e => e.value == params.startMonth)
      }
      this.dialog = true
    },
    //保存
    async save() {
      try {
        this.saving = true
        const data = Object.assign({}, this.form)
        //編集
        if (this.editedIndex >= 0) {
          await API.graphql(graphqlOperation(updateCorporate, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を更新しました' })
        //新規
        } else {
          delete data.id
          const ret = await API.graphql(graphqlOperation(createCorporate, {input: data}))
          this.editedItem.id = ret.data.createCorporate.id
          this.log({ type: this.$route.name, text: '[' + data.name + '] を追加しました' })
        }

        //口座情報の保存
        let bankCnt = 0
        for (const item of this.editedItem.bank) {
          const bank = {
            id: item.id || null,
            corporateID: this.editedItem.id || null,
            name: item.name || null,
            store: item.store || null,
            type: item.type || null,
            no: item.no || null,
            owner: item.owner || null,
          }
          bank.sort = bankCnt++
          if (item.id) {
            await API.graphql(graphqlOperation(updateBank, {input: bank}))
          } else {
            delete bank.id
            await API.graphql(graphqlOperation(createBank, {input: bank}))
          }
        }
        //オリジナルにのみ存在するものは削除
        for (const bank of this.bankOrigin) {
          if (!this.editedItem.bank.find(e => e.id === bank.id)) {
            await API.graphql(graphqlOperation(deleteBank, {
              input: { id: bank.id }
            }))
          }
        }

        //支店・営業所の保存
        let officeCnt = 0
        for (const item of this.editedItem.office) {
          const office = {
            id: item.id || null,
            corporateID: this.editedItem.id || null,
            name: item.name || null,
            post: item.post || null,
            pref: item.pref || null,
            address: item.address || null,
            build: item.build || null,
            tel: item.tel || null,
            fax: item.fax || null,
          }
          office.sort = officeCnt++
          if (item.id) {
            await API.graphql(graphqlOperation(updateOffice, {input: office}))
          } else {
            delete office.id
            await API.graphql(graphqlOperation(createOffice, {input: office}))
          }
        }
        //オリジナルにのみ存在するものは削除
        for (const office of this.officeOrigin) {
          if (!this.editedItem.office.find(e => e.id === office.id)) {
            await API.graphql(graphqlOperation(deleteOffice, {
              input: { id: office.id }
            }))
          }
        }

        this.myAlert(data.name + 'を保存しました', 'success')
        this.dialog = false

      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.name + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteCorporate, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[' + this.editedItem.name + '] を削除しました' })
          this.myAlert(this.editedItem.name + 'を削除しました', 'success')
          this.dialog = false
        }
      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f]) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.logo = null
      this.editedItem.sign = null
      this.editedItem.bank = []
      this.editedItem.office = []
      this.bankOrigin = []
      this.officeOrigin = []
    },
    //口座情報の追加
    addBankRow() {
      this.editedItem.bank.push({
        name: null,
        store: null,
        type: null,
        no: null,
        owner: null,
      })
    },
    //支店・営業所の削除
    trashOffice(index) {
      this.editedItem.office.splice(index, 1)
    },
    //支店・営業所の追加
    addOfficeRow() {
      this.editedItem.office.push({
        name: null,
        post: null,
        pref: null,
        address: null,
        build: null,
        tel: null,
        fax: null,
      })
    },
    //口座情報の削除
    trashBank(index) {
      this.editedItem.bank.splice(index, 1)
    },
    //企業の取得
    async getCorporates(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCorporates, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listCorporates.items) {
        this.desserts.push(data)
      }
      if (query.data.listCorporates.nextToken) this.getCorporates(query.data.listCorporates.nextToken)
    },
  },
  components: {
    Upload,
    draggable,
  },
}
</script>

<style lang='scss' scoped>
.section-title {
  margin: 10px 0;
  padding: 5px 10px;
  font-weight: bold;
  background: #e1ecf3;
}
.bank-table {
  tbody {
    tr {
      &:hover {
        background: transparent !important;
      }
      &.ghost {
        opacity: 0.5 !important;
        background: #c8ebfb !important;
      }
      td {
        .handle {
          &:hover {
            cursor: move;
          }
        }
        
      }
    }
  }
  .table-footer {
    &:first-of-type td {
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }
    &:hover {
      background: #FFF !important;
    }
    td {
      cursor: default !important;
      &.row-ctrl {
        vertical-align: top;
        padding-top: 10px;
        border-bottom: none !important;
      }
    }
  }
}
</style>
